import { render, staticRenderFns } from "./CampaignStatsNew.vue?vue&type=template&id=57170756"
import script from "./CampaignStatsNew.vue?vue&type=script&lang=js"
export * from "./CampaignStatsNew.vue?vue&type=script&lang=js"
import style0 from "./CampaignStatsNew.vue?vue&type=style&index=0&id=57170756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports